export default __webpack_public_path__ + "static/media/arrow-left.da16f2ef.svg";